/* eslint-disable no-return-await */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { instanceConexao } from "services/axiosServices";

/**
 * v2: exige o JWT do Conexão e só responde sobre o dono do token.
 *
 * O `Authorization` é anexado pelo interceptor de `instanceConexao`, por isso não vai explícito.
 * O e-mail continua na rota porque a API o compara com o da claim — pedir o de outra pessoa é 403.
 */
const URL_CHECAR_V2 = "/api/autonomo/v2/checar-por-email/";

export const fetchCheckAutonomo = (email: string, enabled?: boolean): any => {
  const fetch = async (): Promise<any> => {
    const url = `${URL_CHECAR_V2}${email}`;
    const response = await instanceConexao.get(url);

    if (response?.data?.success) {
      return response?.data?.data;
    }
    throw new Error(response?.data?.notifications[0]?.message);
  };

  const query = useQuery({
    queryFn: async () => await fetch(),
    queryKey: ["fetch-check-autonomo", email],
    enabled: !!email && enabled === undefined ? true : enabled,
    refetchOnWindowFocus: false,
  });

  return query;
};

export const getCheckAutonomo = async (email: string): Promise<void> => {
  const url = `${URL_CHECAR_V2}${email}`;

  try {
    const response = await instanceConexao.get(url);
    if (response?.data?.success) {
      if (response?.data?.data === "block") {
        window.location.href = "/block";
      } else localStorage.setItem("isAutonomo", response?.data?.data);
    } else {
      throw new Error(response?.data?.notifications[0]?.message);
    }
  } catch (err) {
    console.log(err);
  }
};
